import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly _permissions = signal<string[]>([]);
  private readonly _isSuperAdmin = signal(false);

  readonly permissions = this._permissions.asReadonly();

  setPermissions(permissions: string[]): void {
    this._permissions.set(permissions);
  }

  setSuperAdmin(val: boolean): void {
    this._isSuperAdmin.set(val);
  }

  hasPermission(permission: string): boolean {
    if (this._isSuperAdmin()) return true;
    return this._permissions().includes(permission);
  }

  clear(): void {
    this._permissions.set([]);
    this._isSuperAdmin.set(false);
  }
}
